import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton, Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import CirrhosisViolenceRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import CirrhosisViolanceCreate from "../create";
import { useTranslate } from "src/locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//OAERDOGAN;452927;28032025
const cirrhosisColumns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return (
        <Link to={`edit/${params.row.id}`}>
          <EditIcon color="info" />
        </Link>
      );
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function CirrhosisViolance() {
  const { t } = useTranslate();
  
  return (
    <BaseMedCardList
      rows={CirrhosisViolenceRows}
      columns={cirrhosisColumns}
      CreateComponent={CirrhosisViolanceCreate}
      title={t("cirrhosis-violance.determination-cirrhosis")}
    >
      <ByzMuiTypography
        sx={{
          fontSize: 13,
          fontWeight: 300,
          whiteSpace: "pre-line",
          wordWrap: "break-word",
          margin: 0,
        }}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ marginTop: "20px" }}
        >
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              padding: "10px",
              textAlign: "left",
              alignSelf: "flex-start",
            }}
          >
            <Grid container spacing={1}>
              <Grid container item spacing={1}>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  Skor
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  Sınıflandırma
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  1 Yıllık Yaşam
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  2 Yıllık Yaşam
                </Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>5-6</Grid>
                <Grid item xs={3}>A</Grid>
                <Grid item xs={3}>%100</Grid>
                <Grid item xs={3}>%85</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>7-9</Grid>
                <Grid item xs={3}>B</Grid>
                <Grid item xs={3}>%80</Grid>
                <Grid item xs={3}>%55-%60</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>10-15</Grid>
                <Grid item xs={3}>C</Grid>
                <Grid item xs={3}>%45</Grid>
                <Grid item xs={3}>%35</Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: "10px" }}>
                {`*Primer bilyer siroz ve pirimer sklerozan klonjit gibi kolesatik hastalıklarda bilüribinin üst sınır değeri 1 puan için 4mgdl, 2 puan için 10mg/dl olarak hesaplanır`}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              borderLeft: "1px solid black",
              padding: "10px",
              textAlign: "left",
              alignSelf: "flex-start",
            }}
          >
            {`MELD skoru=10[0.957 log(serum kreatinin)+0.378 Log(total biluribin)+1.12 log(nR)+0.643]`}
            <br />
            <br />
            {`*Her parametre için minimum kabul edilebilir değer 1, serum kreatinin için maksimum kabul edilebilir değer 4'dür. Maksimum MELD skoru 40 olabilir.`}
            <Grid container spacing={1}>
              <Grid container item spacing={1}>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  Meld Skoru
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                  Mortalite
                </Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>&lt;9</Grid>
                <Grid item xs={3}>%2</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>10-19</Grid>
                <Grid item xs={3}>%5</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>20-29</Grid>
                <Grid item xs={3}>%20</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>30-39</Grid>
                <Grid item xs={3}>%50</Grid>
              </Grid>
              <Grid container item spacing={1}>
                <Grid item xs={3}>&gt;40</Grid>
                <Grid item xs={3}>%70</Grid>
              </Grid>
            </Grid >
          
          </Grid>
        </Grid>
      </ByzMuiTypography>
    </BaseMedCardList>
  );
}

export default CirrhosisViolance;
